export default __webpack_public_path__ + "static/media/equipos-disabled.0889a282.svg";